import { AppearanceStatic } from '../Appearance/AppearanceStatic';
import { AppearanceType } from '../Model/AppearanceType';
import { StaticPaneManager } from '../Manager/StaticPaneManager';
import { StaticPaneFactory } from './StaticPaneFactory';
import { AppearanceModal } from '../Appearance/AppearanceModal';
import { ModalManager } from '../Manager/ModalManager';
import { AppearanceButton } from '../Appearance/AppearanceButton';
import { MobileManager } from '../Manager/MobileManager';
import { ModalFactory } from './ModalFactory';
import { MobileFactory } from './MobileFactory';
import { AppearanceSlider } from '../Appearance/AppearanceSlider';
import { SliderManager } from '../Manager/SliderManager';
import { SliderFactory } from './SliderFactory';
var AppearanceFactory = /** @class */ (function () {
    function AppearanceFactory() {
    }
    AppearanceFactory.build = function (model) {
        switch (model.type) {
            case AppearanceType.Comparer:
                return new AppearanceStatic(new StaticPaneManager(StaticPaneFactory.getStaticPane()), model);
            case AppearanceType.Static:
                return new AppearanceStatic(new StaticPaneManager(StaticPaneFactory.getStaticPane()), model);
            case AppearanceType.Modal:
                return new AppearanceModal(new ModalManager(ModalFactory.getModal()));
            case AppearanceType.Button:
                return new AppearanceButton(new MobileManager(MobileFactory.getButton()), model);
            case AppearanceType.Slider:
                return new AppearanceSlider(new SliderManager(SliderFactory.getSlider()), model);
            default:
                return null;
        }
    };
    return AppearanceFactory;
}());
export { AppearanceFactory };
